import { render, staticRenderFns } from "./AdminAffiliatePromotionEditPage.vue?vue&type=template&id=14c63faa"
import script from "./AdminAffiliatePromotionEditPage.vue?vue&type=script&lang=js"
export * from "./AdminAffiliatePromotionEditPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports